function getFileExtension(filename: string) {
  return filename.split(".").pop();
}

export default getFileExtension;
